<template>
  <div class="signature-pad-input-with-button">
    <div v-if="modelValue" class="bg-white mb-2 p-2 border">
      <img class="w-100" :src="$core.$imgix.buildUrl(modelValue)" alt="署名" />
    </div>
    <span
      v-if="!disabled"
      class="btn btn-primary btn-sm"
      @click.prevent="() => $refs.signatureModal.show()"
    >
      手書き署名を{{modelValue ? '変更' : '入力' }}
    </span>
    <span
      v-if="modelValue && !disabled"
      class="btn btn-danger btn-sm ml-2"
      @click.prevent="() => handleSignatureClear()"
    >
      削除
    </span>
    <b-modal
      ref="signatureModal"
      title="手書き署名を入力"
      hide-footer
      size="lg"
      centered
    >
      <SignaturePad
        @end="handleSignatureEnd"
        @clear="
          () => {
            signature = null
          }
        "
      />
      <div class="d-flex justify-content-center gap-2">
        <span
          class="btn btn-outline-secondary btn-sm"
          @click="() => {
            $refs.signatureModal.hide()
          }">
          キャンセル
        </span>
        <span class="btn btn-outline-primary btn-sm" @click="handleSignatureSave">
          保存
        </span>
      </div>
    </b-modal>
  </div>
</template>

<script lang="ts">
import { PropType } from 'vue'
import SignaturePad from './SignaturePad.vue'
import { generateStrongTimeStampString } from '../../../CORE/src/common/utils'

const base64ToFile = async (base64String: string, fileName: string): Promise<File> => {
  const res = await fetch(base64String)
  const blob = await res.blob()
  return new File([blob], fileName, { type: blob.type })
}

export default {
  name: 'SignaturePadInputWithButton',
  components: {
    SignaturePad,
  },
  props: {
    modelValue: {
      type: String as PropType<string>,
      default: '',
    },
    disabled: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  data() {
    return {
      signature: null as string | null,
    }
  },
  methods: {
    handleSignatureEnd(signature) {
      console.log({ signature })
      this.signature = signature
    },
    handleSignatureClear() {
      this.signature = null
      this.$emit('update:modelValue', '')
      this.$emit('signature-clear')
      this.$refs.signatureModal.hide()
    },
    async handleSignatureSave() {
      if(!this.signature) {
        this.$emit('update:modelValue', '')
        this.$emit('signature-save', '')
        return
      }
      // ファイルをアップロードする
      const fileObject = await base64ToFile(
        this.signature,
        `sign-${$core.$utils.generateStrongTimeStampString()}.png`
      )
      const uploadResult = await $core.$fileManager.upload(
        fileObject,
      )
      this.$emit('update:modelValue', uploadResult.filePath)
      this.$emit('signature-save', uploadResult.filePath)
      this.$refs.signatureModal.hide()
    },
  },
}
</script>
